// extracted by mini-css-extract-plugin
export default {"content":"ContentPanel__content___YSLYa","contentMobile":"ContentPanel__contentMobile___dXkdk"};